import React, {useEffect, useState, Fragment} from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {FuelCard, Truck, TruckGroup} from "../Pages/Trucks/TruckTypes";
import ApiRest from "../../service/ApiRest";
import BackBtn from "../BackBtn";

interface Props {
    element: FuelCard,
    saveData: (number: string,
               truckGroup: number,
               truck: number,
               supplier: string,
               pin: string,
               date: string,
               status: number,
               comment: string,
    ) => void,
}

export default function FuelCardForm(props: Props) {
    const {element, saveData} = props;
    const [number, setNumber] = useState(element.number);
    const [truckGroup, setTruckGroup] = useState(element.truckGroup.toString());
    const [truck, setTruck] = useState(element.truck.toString());

    const [supplier, setSupplier] = useState(element.supplier);
    const [pin, setPin] = useState(element.pin);
    const [date, setDate] = useState(element.date);
    const [status, setStatus] = useState(element.status);

    const [comment, setComment] = useState(element.comment);


    const [groups, setGroups] = useState([]);
    const [trucks, setTrucks] = useState([]);

    const getListData = () => {
        ApiRest.getElements('truck-group').then(res => {
            if (res) {
                setGroups(res);
            }
        });
        ApiRest.getElements('truck').then(res => {
            if (res) {
                setTrucks(res.filter((t: Truck) => !!t.locktrackerNumber));
            }
        });
    }

    useEffect(getListData, []);

    return (
        <Fragment>
            <Card>
                <Card.Header><BackBtn/>Kortelė</Card.Header>
                <Card.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Tiekėjas</Form.Label>
                            <Form.Control value={supplier} onChange={e => setSupplier(e.target.value)}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Kortelės nr.</Form.Label>
                            <Form.Control value={number} onChange={e => setNumber(e.target.value)}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Vilkikas</Form.Label>
                            <Form.Control
                                as="select"
                                className="mr-sm-2"
                                value={truck}
                                onChange={(e) => setTruck(e.target.value)}
                            >
                                <option value="0">Pasirinkite...</option>
                                {trucks.map((truck: Truck) => <option key={'opt-g' + truck.id}
                                                                      value={truck.id}>{truck.name}</option>)}

                            </Form.Control>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Pin</Form.Label>
                            <Form.Control value={pin} onChange={e => setPin(e.target.value)}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Galiojimo data</Form.Label>
                            <Form.Control value={date} onChange={e => setDate(e.target.value)}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Grupė</Form.Label>
                            <Form.Control
                                as="select"
                                className="mr-sm-2"
                                value={truckGroup}
                                onChange={(e) => setTruckGroup(e.target.value)}
                            >
                                <option value="0">Pasirinkite...</option>
                                {groups.map((group: TruckGroup) => <option key={'opt-g' + group.id}
                                                                           value={group.id}>{group.name}</option>)}

                            </Form.Control>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Statusas</Form.Label>
                            <Form.Control
                                as="select"
                                className="mr-sm-2"
                                value={status}
                                onChange={(e) => setStatus(parseInt(e.target.value, 10))}
                            >
                                <option value="0">Neaktyvios</option>
                                <option value="10">Aktyvios</option>

                            </Form.Control>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Komentaras</Form.Label>
                            <Form.Control as={"textarea"} value={comment} onChange={e => setComment(e.target.value)}/>
                        </Form.Group>

                    </Form>
                </Card.Body>
                <Card.Footer>
                    <Row>
                        <Col>

                        </Col>
                        <Col className={"text-right"}>
                            <Button type={"button"} variant={"primary"}
                                    onClick={() => saveData(
                                        number,
                                        parseInt(truckGroup, 10),
                                        parseInt(truck, 10),
                                        supplier,
                                        pin,
                                        date,
                                        status,
                                        comment
                                    )}>Išsaugoti</Button>
                        </Col>
                    </Row>
                </Card.Footer>
            </Card>
        </Fragment>)
}
